import React, { useState } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import {
    hasPermission,
    assetsManage
} from '../../Utils/Common';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import CoreDocumentTypesTabPanel  from "./CoreDocumentTypesTabPanel";
import EnvisionDocumentTypesTabPanel  from "./EnvisionDocumentTypesTabPanel";
import PageHeader from "../../components/PageHeader/PageHeader";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// mui does not support a default TabPanel out of the box except in experimental lab package so create one from examples
import TabPanel from '../../components/TabPanel/TabPanel';

const DocumentTypes = () => {
    const { permissions } = usePermissionContext();
    const [coreDocumentType, setCoreDocumentType] = useState(false);
    const [enVisionDocumentType, setenVisionDocumentType] = useState(false);

    const initialSnackbarState = {
        open: false,
        message: '',
        alertTitle: '',
        severity: 'info',
        hideDuration: 1000
    };

    const [notify, setNotify] = useState(
        initialSnackbarState
    );

    //const hasPlatformManage = hasPermission(permissions, platformManage);
    const hasAssetsManage = hasPermission(permissions, assetsManage);
    // define names of tabs
    const tabs = [
        {
            label: 'Core Document Type',
            value: 'coreDocumentType',
            component: <CoreDocumentTypesTabPanel setNotify={setNotify} coreDocumentType={coreDocumentType} setCoreDocumentType={setCoreDocumentType} />
        },
        {
            label: 'enVision Document Type',
            value: 'enVisionDocumentType',
            component: <EnvisionDocumentTypesTabPanel  setNotify={setNotify} enVisionDocumentType={enVisionDocumentType} setenVisionDocumentType={setenVisionDocumentType} />
        },

    ];

    let selectedIndex = sessionStorage.getItem("document_type") !== null ? sessionStorage.getItem("document_type") : 0
    const [value, setValue] = useState(+selectedIndex);    // set to previous visited connector schedule tab
    const [selectedTab, setSelectedTab] = useState(tabs[value].value);

    const handleChange = (event, newValue) => {
        sessionStorage.setItem("document_type", newValue)
        setSelectedTab(tabs[newValue].value);

        setValue(newValue);

        getPageHeader();       // needed??
    };


    // initially we needed different page headers. Requirement was changed. Technically we don't need this but leaving for now
    const getPageHeader = () => {

        switch (selectedTab) {
            // common page header on all tabs
            case 'coreDocumentType':
                return (<PageHeader title='Document Types' includeCreate={hasAssetsManage} createTitle='Create Core Document' onCreate={onCoreDocumentType} />);  // if need create button
            case 'enVisionDocumentType':
                return (<PageHeader title='Document Types' includeCreate={false}  />);  // if do not need create button
            default:
                return (<PageHeader title='Document Types' includeCreate={false} />);
        }
    };

    const onCoreDocumentType = () => {
        // console.log("Create schedule button clicked");

        setCoreDocumentType(true);
    };


    return (
        <>

            <AlertSnackbar
                notify={notify}
                setNotify={setNotify} />

            {getPageHeader()}


            <Tabs value={value} onChange={handleChange} aria-label="document types tabs">
                {tabs.map((tab) => <Tab key={`${tab.value}-tab`} id={`${tab.value}-tab`} label={tab.label} sx={{ textTransform: 'none' }} />)}
            </Tabs>

            {tabs.map((tab, index) => <TabPanel key={`${tab.value}-panel`} id={`${tab.value}-panel`} value={value} index={index}>{tab.component}</TabPanel>)}


        </>
    );
}

export default DocumentTypes;